/*@ngInject*/
const UITooltipDirective = function ($document, $timeout, submissionConstant, coreConstant, $sanitize) {
    let linkFunction = function ($scope, $elm, $attr) {

        let timeoutList = [],
            body = angular.element('body'),
            formViewer = angular.element('.formViewer .formViewerContainer:first-child'),
            tooltip,
            position,
            arrow,
            arrowBackground;


        function showTooltip(overwriteText) {
            let tooltipConfig = {};
            if ($scope.$ctrl) {
                tooltipConfig = $scope.$ctrl.fieldStructure ? $scope.$ctrl.fieldStructure.dynamicProperties.tooltip : $scope.$ctrl.tooltip;
            }

            if (_.isNil(tooltipConfig)) {
                tooltipConfig = {'type': 'tooltipPopover', 'delay': 500, 'message': overwriteText};
            }
            if (overwriteText && tooltipConfig.type !== 'errorPopover') {
                tooltipConfig.message = overwriteText;
            }

            let hasTooltipMessage = tooltipConfig && tooltipConfig.message,
                showTooltipDelay = tooltipConfig ? tooltipConfig.delay : 0,
                activeElement = $document[0].activeElement,
                hasFocus = activeElement ? activeElement.className === $elm[0].className : false,
                isEnabled = _.isUndefined($attr.uiTooltipEnabled) || (!_.isUndefined($attr.uiTooltipEnabled) && $attr.uiTooltipEnabled !== 'false'),
                shouldAddTooltip = !tooltip && hasTooltipMessage && isEnabled;

            if (shouldAddTooltip) {
                position = $elm.offset();
                body.append(
                    '<div class="uiTooltip ' + tooltipConfig.type + '">' +
                    '<div class="message">' + $sanitize(tooltipConfig.message) + '</div>' +
                    '<div class="arrowBackground"></div>' +
                    '<div class="arrow"></div>' +
                    '</div>');
                tooltip = angular.element('.uiTooltip');
                arrow = angular.element('.arrow');
                arrowBackground = angular.element('.arrowBackground');
                tooltip.css('opacity', 0);
                tooltip.css('top', position.top - tooltip[0].offsetHeight - 1);
                if ((tooltip[0].offsetWidth / 2) > position.left) {
                    tooltip.css('left', position.left - ($elm[0].offsetWidth / 2 ));
                    arrow.css('left', $elm[0].offsetWidth);
                    arrowBackground.css('left', $elm[0].offsetWidth);
                } else {
                    tooltip.css('left', position.left - (tooltip[0].offsetWidth / 2) + ($elm[0].offsetWidth / 2 ));
                }

                formViewer.on('scroll', removeTooltip);
                $scope.$on('$stateChangeStart', removeTooltip);
                $scope.$on(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP, removeTooltip);

                timeoutList.push($timeout(function () {
                    if (tooltip) {
                        tooltip.css('opacity', 1);
                    }
                }, showTooltipDelay));
            }
        }

        function removeTooltip() {
            if (tooltip) {
                tooltip.css('opacity', 0);

                timeoutList.push($timeout(function () {
                    formViewer.off('scroll', removeTooltip);
                    angular.element('.uiTooltip').remove();
                    tooltip = null;
                }, 200));
            }
        }

        function onClick() {
            if (!$attr.uiTooltipUseClick) {
                removeTooltip();
            }
            else {
                if (!tooltip) {
                    showTooltip($attr.uiTooltipText);
                }
                else {
                    removeTooltip();
                }
            }
        }

        function onMouseEnter() {
            if (!$attr.uiTooltipUseClick) {
                let $element = $elm;
                if ($attr.uiTooltipTextElement) {
                    $element = $elm.find('.' + $attr.uiTooltipTextElement + ':visible');
                }

                if ($element[0].scrollWidth > $element.innerWidth()) {
                    showTooltip($attr.uiTooltipText);
                } else if($attr.uiTooltipMessage){
                    showTooltip($attr.uiTooltipMessage);
                }
            }
        }

        $scope.$on(coreConstant.event.classCode.HIDE_TOOLTIP, function () {
            if (tooltip) {
                tooltip.css('opacity', 0);
                formViewer.off('scroll', removeTooltip);
                angular.element('.uiTooltip').remove();
                tooltip = null;
            }
        });

        $elm.on('click', onClick);
        $elm.on('mouseenter', onMouseEnter);
        $elm.on('mouseleave', removeTooltip);
        $elm.on('focus', removeTooltip);

        $scope.$on('$destroy', function () {
            $elm.off('click', onClick);
            $elm.off('mouseenter', onMouseEnter);
            $elm.off('mouseleave', removeTooltip);
            $elm.off('focus', removeTooltip);

            if (tooltip !== null) {
                formViewer.off('scroll', removeTooltip);
                angular.element('.uiTooltip').remove();
                tooltip = null;
            }

            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiTooltip', UITooltipDirective);
